import { Controller } from '@hotwired/stimulus'

const COOLDOWN = 90
const CONFIRMATION_MS = 4000

export default class extends Controller {
  static targets = ['button', 'countdown', 'confirmation']

  connect() {
    this.start()
  }

  disconnect() {
    this.stop()
    if (this.confirmationTimer) clearTimeout(this.confirmationTimer)
  }

  // Resend without leaving the page: POST as JSON, restart the cooldown and
  // confirm. The <form> still submits (full page) if JS is unavailable.
  // No CSRF token needed: the /sign/ flow skips forgery protection
  // (Sign::BaseController), auth is carried by the JWT in the URL.
  async resend(event) {
    event.preventDefault()
    if (this.buttonTarget.disabled) return

    this.start()
    try {
      const response = await fetch(this.element.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.element),
      })
      if (response.ok) this.confirm()
    } catch {
      // Network error: the cooldown still guards against spamming.
    }
  }

  start() {
    this.stop()
    this.remaining = COOLDOWN
    this.disable()
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  tick() {
    if (this.remaining <= 0) {
      this.stop()
      this.enable()
      return
    }

    this.countdownTarget.textContent = `(${this.remaining}s)`
    this.remaining -= 1
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  disable() {
    this.buttonTarget.disabled = true
  }

  enable() {
    this.buttonTarget.disabled = false
    this.countdownTarget.textContent = ''
  }

  confirm() {
    if (!this.hasConfirmationTarget) return

    this.confirmationTarget.classList.remove('hidden')
    if (this.confirmationTimer) clearTimeout(this.confirmationTimer)
    this.confirmationTimer = setTimeout(() => {
      this.confirmationTarget.classList.add('hidden')
    }, CONFIRMATION_MS)
  }
}
